if (!customElements.get('cotton-card-size')) {
  customElements.define('cotton-card-size', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const select = this.querySelector('select');
      const card = this.closest('product-card');
      const originalPrice = card.querySelector('price-list');
      const quickBuy = card.querySelector('.product-card__quick-buy');
      const result = this.querySelector('[data-result]');
      const link = this.querySelector('[data-choice]');
      const originalLinks = [...card.querySelectorAll('.product-card__link-wrapper, .product-card__title a')].map(a => [a,a.getAttribute('href')]);
      const state = [originalPrice,quickBuy].filter(Boolean).map(el=>[el,el.hidden]);
      const applySelection = () => {
        const option = select.selectedOptions[0];
        const chosen = Boolean(select.value);
        result.hidden = !chosen;
        state.forEach(([el,hidden])=>{el.hidden=chosen||hidden;});
        if (!chosen) {originalLinks.forEach(([a,href])=>a.setAttribute('href',href));return;}
        const available = option.dataset.available === 'true';
        this.querySelector('strong[data-price]').textContent = option.dataset.price;
        this.querySelector('[data-status]').textContent = available ? 'Seçili ölçünün toplam fiyatı' : 'Bu hazır ölçü şu anda satışa açık değil.';
        link.href = select.value;
        link.textContent = available ? 'Bu ölçüyü incele' : 'Bu ölçünün durumunu incele';
        originalLinks.forEach(([a])=>a.href=select.value);
      };
      select.addEventListener('change', applySelection);
      const filters = JSON.parse(this.dataset.sizeFilters || '[]');
      if (filters.length) {
        const normalize = value => {
          const match = value.trim().match(/^(\d+)\s*[x×]\s*(\d+)\s*(?:cm)?$/i);
          return match ? match[1] + 'x' + match[2] : null;
        };
        const size = filters.length === 1 ? normalize(filters[0]) : null;
        const matches = size ? [...select.options].filter(option => option.value && normalize(option.textContent.split(' — ')[0]) === size) : [];
        select.value = matches.length === 1 ? matches[0].value : '';
      }
      applySelection();
    }
  });
}
